import * as AgGrid from "ag-grid-community";
import * as dom from "utils/dom";

function getActionButton(params: AgGrid.CellClickedEvent): HTMLButtonElement {
  const $target = params.event.target as HTMLElement;
  if (!$target) {
    return;
  }
  const $button = $target.tagName.toLowerCase() == "button" ? $target : $target.closest("button");
  return $button as HTMLButtonElement;
}

export async function onActionCellClicked<T>(
  params: AgGrid.CellClickedEvent,
  handler: (action: T) => Promise<void> | void,
) {
  const button = getActionButton(params);

  if (!button) return;

  dom.preventButtonDoubleClick(
    button,
    async () => {
      await handler(button.dataset["action"] as T);
    },
    1500,
  )();
}
